import type { HouseType, Residents } from '@essent/estimate-consumption';
import { validateSequential } from '@innogy/utils-deprecated';
import type { Action } from '@ngrx/store';
import { createReducer } from '@ngrx/store';
import type { FormGroupState } from 'ngrx-forms';
import {
  createFormGroupState,
  markAsDirty,
  markAsSubmitted,
  MarkAsSubmittedAction,
  markAsTouched,
  markAsUnsubmitted,
  onNgrxForms,
  onNgrxFormsAction,
  reset,
  ResetAction,
  setValue,
  updateGroup,
  wrapReducerWithFormStateUpdate,
} from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';

export const enum SupplyType {
  E_AND_G = 'ELECTRICITY_AND_GAS',
  E_ONLY = 'ELECTRICITY',
}

export const FORM_ID = 'retentionCalculateUsageQuestionnaireForm';

export interface FormValues {
  residents?: Residents;
  houseType?: HouseType;
  supplyType?: SupplyType;
}
export const residentsControlId = `${FORM_ID}.residents`;
export const houseTypeControlId = `${FORM_ID}.houseType`;
export const supplyTypeControlId = `${FORM_ID}.supplyType`;

export interface UsageQuestionnaireState {
  formState: FormGroupState<FormValues>;
}

export const initialFormState = {
  residents: undefined,
  houseType: undefined,
  supplyType: undefined,
};

export const initialFormGroupState = createFormGroupState<FormValues>(
  FORM_ID,
  initialFormState
);

export const initialState: UsageQuestionnaireState = {
  formState: initialFormGroupState,
};

export const validateAndUpdateForms = (state: UsageQuestionnaireState) => {
  return updateGroup<FormValues>({
    residents: validateSequential(required),
    houseType: validateSequential(required),
    supplyType: validateSequential(required),
  })(state.formState);
};

const _reducer = createReducer(
  initialState,
  onNgrxForms(),
  onNgrxFormsAction(MarkAsSubmittedAction, (state, action) => {
    if (action.controlId === FORM_ID) {
      let validatedFormState = validateAndUpdateForms(state);
      validatedFormState = markAsDirty(validatedFormState);
      validatedFormState = markAsTouched(validatedFormState);
      validatedFormState = validatedFormState.isValid
        ? markAsSubmitted(validatedFormState)
        : markAsUnsubmitted(validatedFormState);
      return { ...state, formState: validatedFormState };
    }
    return state;
  }),
  onNgrxFormsAction(ResetAction, (state, action) => {
    if (action.controlId === FORM_ID) {
      const formState = setValue(state.formState, initialFormState);

      return {
        ...state,
        formState: reset(formState),
      };
    }

    return state;
  })
);

const wrappedReducer = wrapReducerWithFormStateUpdate(
  _reducer,
  (state) => state.formState,
  (_, state) => validateAndUpdateForms(state)
);

export function usageQuestionnaireReducer(
  state: UsageQuestionnaireState = initialState,
  action: Action
): UsageQuestionnaireState {
  return wrappedReducer(state, action);
}
